module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/F7yZQv/tc-custom/9781613122075.jpg?1726444246418",
      "alt": "This image is the cover for the book Misfit"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Misfit\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A half-demon teenager learns the dangerous secret of her true powers in this “unusually profound urban-fantasy . . . thoughtful, scary and captivating” ("), _c('i', [_vm._v("Kirkus")]), _vm._v(", starred review).")]), _c('br'), _c('br'), _vm._v("Jael has always felt like a freak. She’s never kissed a boy, she never knew her mom, and her dad’s always been superstrict—but that’s probably because her mom was a demon, which makes Jael half demon and most definitely not a normal sophomore girl. But on her sixteenth birthday, a mysterious present unlocks her family’s dangerous history—and Jael’s untapped potential. "), _c('br'), _c('br'), _vm._v("What was merely an embarrassing secret suddenly becomes a terrifying reality. Jael must learn to master her demon side in order to take on a vindictive Duke of Hell, while also dealing with a twisted priest, best-friend drama, and a spacey blond skater boy who may have hidden depths.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jon Skovron\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jon Skovron’s previous novel, Struts & Frets, was heralded by the Washington Post Book World in a review that said, “Skovron perfectly captures that passion—sometimes fierce, sometimes shy—that drives so many young artists to take the raw stuff of life and ‘transform it into something beautiful.’” He lives in Washington, DC.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Abrams\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0